var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  Card: () => Card
});
class Card {
  constructor(cardManager) {
    this.cardManager = cardManager;
    if (cardManager.getUserCardsCache()) {
      const userCardsCache = cardManager.getUserCardsCache();
      this.cache = userCardsCache[this.cardManager.getId()];
    }
  }
  getYayoyakisSiblings() {
    return [];
  }
  isFiltered() {
    return false;
  }
  isReviewable() {
    return this.cardManager.isReviewable();
  }
  isReviewed() {
    var _a;
    if (!this.isReviewable()) {
      return false;
    }
    return ((_a = this.cache) == null ? void 0 : _a.value) ? this.cache.value[this.getIndex()] : false;
  }
  hasDefaultValue() {
    return this.cardManager.getYayoyakisSiblings(this.getIndex()).every((yayoyaki) => yayoyaki.isVisual() || yayoyaki.isDefaultValue());
  }
  getCardGroupRenderForm() {
    return this.cardManager.getCardGroupRenderForm();
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Card
});
